import api from '../api/properties'
import apiN from '../api/administrativeArea'
import { loadPropertyTypes, receivePropertyTypes, receiveOperationTypes, load, loadPropertyTypesByOperation} from './propiedades'
import { receiveAdministrativeAreas, loadAdministrativeAreas } from './administrativeArea'
import { fetchSection, fetchFilteredAdministrativeAreas } from './api'
import { setVentureId } from './entrepreneurship'
import * as urls from '../constants/api'

// Actions
export const actionTypes = {
  SET_OPERACION: 'searchBar/SET_OPERACION',
  ADD_OPERATION_TYPE: 'searchBar/ADD_OPERATION_TYPE',
  SET_AMBIENTS: 'searchBar/SET_AMBIENTS',
  ADD_AMBIENTS: 'searchBar/ADD_AMBIENTS',
  SET_BATHS: 'searchBar/SET_BATHS',
  ADD_BATHROOMS: 'searchBar/ADD_BATHROOMS',
  SET_GARAGES: 'searchBar/SET_GARAGES',
  ADD_GARAGES: 'searchBar/ADD_GARAGES',
  ADD_BEDROOMS: 'searchBar/ADD_BEDROOMS',
  ADD_NAVES: 'searchBar/ADD_NAVES',
  SET_ROOMS: 'searchBar/SET_ROOMS',
  SET_NAVES: 'searchBar/SET_NAVES',
  SET_CATEGORY: 'searchBar/SET_CATEGORY',
  SET_UBICATION: 'searchBar/SET_UBICATION',
  SET_UNIT_STATE: 'searchBar/SET_UNIT_STATE',
  SET_PLANT: 'searchBar/SET_PLANT',
  SET_TERRAIN: 'searchBar/SET_TERRAIN',
  SET_AVENUE: 'searchBar/SET_AVENUE',
  SET_FOCUS: 'searchBar/SET_FOCUS',
  SET_AREA_MIN: 'searchBar/SET_AREA_MIN',
  SET_AREA_MAX: 'searchBar/SET_AREA_MAX',
  SET_AREA_MIN_LOW: 'searchBar/SET_AREA_MIN_LOW',
  SET_AREA_MAX_LOW: 'searchBar/SET_AREA_MAX_LOW',
  SET_PRICE_MIN: 'searchBar/SET_PRICE_MIN',
  SET_PRICE_MAX: 'searchBar/SET_PRICE_MAX',
  SET_PROPERTY_TYPE: 'searchBar/SET_PROPERTY_TYPE',
  ADD_PROPERTY_TYPE: 'searchBar/ADD_PROPERTY_TYPE',
  ADD_NEIGHBORHOOD:'searchBar/ADD_NEIGHBORHOOD',
  ADD_ADMINISTRATIVEAREA:'searchBar/ADD_ADMINISTRATIVEAREA',
  ADD_ZONE: 'searchBar/ADD_ZONE',
  TOGGLE_PANEL: 'searchBar/TOGGLE_PANEL',
  SAVE_ORIGIN_PATH: 'searchBar/SAVE_ORIGIN_PATH',
  SAVE_ORIGIN_OFFICE: 'searchBar/SAVE_ORIGIN_OFFICE',
  CHANGE_CURRENCY: 'searchBar/CHANGE_CURRENCY',
  SEARCH_FROM_MENU: 'searchBar/SEARCH_FROM_MENU',
  SEARCH_FROM_SEARCHBAR: 'searchBar/SEARCH_FROM_SEARCHBAR',
  CHECK_OPERATION_TYPE: 'home/CHECK_OPERATION_TYPE',
  RESET_FORM: 'searchBar/RESET_FORM',
  RESET_FILTERS: 'searchBar/RESET_FILTERS',
  ERROR: 'searchBar/ERROR',
  ADD_TIPO_PROPIEDAD: 'searchBar/ADD_TIPO_PROPIEDAD',
  CHANGE_PROFESSIONAL_USE: 'searchBar/CHANGE_PROFESSIONAL_USE',
	RECEIVE_ALL_PROPERTY_TYPES: 'searchBar/RECEIVE_ALL_PROPERTY_TYPES',
  CHANGE_NEW: 'searchBar/CHANGE_NEW',
	SAVE_SUB_PROPERTY_TYPE: 'searchBar/SAVE_SUB_PROPERTY_TYPE',
	ADD_SUB_TIPO_DEPARTAMENTO: 'searchBar/ADD_SUB_TIPO_DEPARTAMENTO',
	POP_SUB_TIPO_DEPARTAMENTO: 'searchBar/POP_SUB_TIPO_DEPARTAMENTO',
	RESET_SUB_DEPARTAMENTO_TYPE: 'searchBar/RESET_SUB_DEPARTAMENTO_TYPE',
	RESET_SUB_PROPERTY_TYPE: 'searchBar/RESET_SUB_PROPERTY_TYPE',
	RESET_PROPERTY_TYPE: 'searchBar/RESET_PROPERTY_TYPE',
  SAVE_ORIGIN_PATH_NO_RESET: 'searchBar/SAVE_ORIGIN_PATH_NO_RESET',
  LOAD_PARAMS_FROM_URL: 'searchBar/LOAD_PARAMS_FROM_URL',
}

export const setOperacion = (value) => {
  return (dispatch, getStore) => {
    dispatch(setOperacionSync(value))
    dispatch(loadAdministrativeAreas())
    //dispatch(loadPropertyTypesByOperation());
  }
}

export const saveSubPropertyType = (sub_property_type) => {
	return {
		type: actionTypes.SAVE_SUB_PROPERTY_TYPE,
		sub_property_type
	}
}

export const resetSubDepartamentoType = () => {
	return {
		type: actionTypes.RESET_SUB_DEPARTAMENTO_TYPE
	}
}

// Action creators
export const setOperacionSync = (value) => {
  return {
    type: actionTypes.SET_OPERACION,
    value
  }
}

export const addOperationType = (value) => {
  return (dispatch, getStore) => {
    dispatch(resetSubPropertyType())
    dispatch(resetFiltersSync())
    dispatch(setOperation(value))
    dispatch(loadAdministrativeAreas())
    dispatch(load(urls.PROPERTIES))
  }
}

export const setOperation = (value) => {
  return {
    type: actionTypes.ADD_OPERATION_TYPE,
    value
  }
}

export const setPropertyType = (value) => {
  return (dispatch, getStore) => {
		if(value.is_sector == 0 ) {
			dispatch(saveSubPropertyType(value))
			dispatch(setPropertyTypeSync(value))
		} else {
			dispatch(setPropertyTypeSync(value))
		}
    dispatch(loadAdministrativeAreas())
  }
}

export const setPropertyTypeSync = (value) => {
  return {
    type: actionTypes.SET_PROPERTY_TYPE,
    value
  }
}

export const receiveAllPropertyTypes = (data) => {
	return {
		type: actionTypes.RECEIVE_ALL_PROPERTY_TYPES,
		property_types: data
	}

}

// Al cambiar de tipo de propiedad ejecuta esto
export const addPropertyType = (value) => {
  return (dispatch, getStore) => {
    dispatch(resetSubPropertyType())
    dispatch(resetFiltersSync())
    dispatch(setType(value))
    dispatch(loadAdministrativeAreas())
    dispatch(load(urls.PROPERTIES))
  }
}

export const addSubPropertyType = (value) => {
  return (dispatch, getStore) => {
    dispatch(saveSubPropertyType(value))
    dispatch(loadAdministrativeAreas())
    dispatch(load(urls.PROPERTIES))
  }
}

export const setType = (value) => {
  return {
    type: actionTypes.ADD_PROPERTY_TYPE,
    value
  }
}

export const saveOriginPath = (value) => {

  return (dispatch, getStore) => {
    dispatch(saveOriginPathSync(value))
  }
}

export const saveOriginPathByPropertyType = (value) => {
	var originPath = null
	switch (value) {
		case 'Departamento':
		case 'Casa':
		case 'Casa en barrio cerrado':
		case 'Terreno en barrio cerrado':
		case 'Vivienda':
			originPath = { id: '6', name: 'Residencial'}
			break
		case 'Local':
			originPath = { id: '3', name: 'Locales'}
			break
		case 'Oficina':
			originPath = { id: '1', name: 'Oficina'}
			break
		case 'Campo':
			originPath = { id: '9', name: 'Campos'}
			break
		case 'Terreno':
			originPath = { id: '7', name: 'Terrenos'}
			break
		case 'Industria':
			originPath = { id: '2', name: 'Industrias'}
			break
		case 'Hotel':
			originPath = { id: '13', name: 'Hoteles'}
			break
		case 'Emprendimiento':
			originPath = { id: '8', name: 'Emprendimientos'}
			break
		default:
			originPath = { id: '', name: '/'}

	}
	return (dispatch, getStore) => {
		dispatch(saveOriginPathSyncNoReset(originPath))
	}
}

export const saveOriginPathSync = (value) => {
  return {
    type: actionTypes.SAVE_ORIGIN_PATH,
    value
  }
}

export const saveOriginPathSyncNoReset = (value) => {
  return {
    type: actionTypes.SAVE_ORIGIN_PATH_NO_RESET,
    value
  }
}

export const saveOriginOffice = (value) => {
  return (dispatch, getStore) => {
    dispatch(resetPropertyType())
    dispatch(saveOriginOfficeSync(value))
    dispatch(loadAdministrativeAreas())
    dispatch(getPropertyTypes({
      subsidiary_type_id: parseInt(value.subsidiary),
      with_sub_types: (parseInt(value.subsidiary) !== 0)
     }))
  }
}

export const saveOriginOfficeSync = (value) => {
  return {
    type: actionTypes.SAVE_ORIGIN_OFFICE,
    value
  }
}

export const setAmbients = (value) => {
  return {
    type: actionTypes.SET_AMBIENTS,
    value
  }
}

export const setBaths = (value) => {
  return {
    type: actionTypes.SET_BATHS,
    value
  }
}

export const setGarages = (value) => {
  return {
    type: actionTypes.SET_GARAGES,
    value
  }
}

export const setRooms = (value) => {
  return {
    type: actionTypes.SET_ROOMS,
    value
  }
}

export const setNaves = (value) => {
  return {
    type: actionTypes.SET_NAVES,
    value
  }
}

export const setCategory = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setCategorySync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else {
      dispatch(setCategorySync(value))
    }
  }
}

export const setCategorySync = (value) => {
  return {
    type: actionTypes.SET_CATEGORY,
    value
  }
}

export const setPlant = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setPlantSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setPlantSync(value))
    }
  }
}

export const setPlantSync = (value) => {
  return {
    type: actionTypes.SET_PLANT,
    value
  }
}

export const setUbication = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setUbicationSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setUbicationSync(value))
    }
  }
}

export const setUbicationSync = (value) => {
  return {
    type: actionTypes.SET_UBICATION,
    value
  }
}

export const setUnitState = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setUnitStateSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setUnitStateSync(value))
    }
  }
}

export const setUnitStateSync = (value) => {
  return {
    type: actionTypes.SET_UNIT_STATE,
    value
  }
}

export const setTerrain = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setTerrainSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setTerrainSync(value))
    }
  }
}

export const setTerrainSync = (value) => {
  return {
    type: actionTypes.SET_TERRAIN,
    value
  }
}

export const setAvenue = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setAvenueSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setAvenueSync(value))
    }
  }
}

export const setAvenueSync = (value) => {
  return {
    type: actionTypes.SET_AVENUE,
    value
  }
}

export const setFocus = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setFocusAsync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setFocusAsync(value))
    }
  }
}

export const setFocusAsync = (value) => {
  return {
    type: actionTypes.SET_FOCUS,
    value
  }
}

export const setAreaMin = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setAreaMinSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setAreaMinSync(value))
    }
  }
}

export const setAreaMinSync = (value) => {
  return {
    type: actionTypes.SET_AREA_MIN,
    value
  }
}

export const setAreaMax = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setAreaMaxSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setAreaMaxSync(value))
    }
  }
}

export const setAreaMaxSync = (value) => {
  return {
    type: actionTypes.SET_AREA_MAX,
    value
  }
}

export const setAreaMinLow = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setAreaMinLowAsync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setAreaMinLowAsync(value))
    }
  }
}

export const setAreaMinLowAsync = (value) => {
  return {
    type: actionTypes.SET_AREA_MIN_LOW,
    value
  }
}

export const setAreaMaxLow = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setAreaMaxLowSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setAreaMaxLowSync(value))
    }
  }
}

export const setAreaMaxLowSync = (value) => {
  return {
    type: actionTypes.SET_AREA_MAX_LOW,
    value
  }
}

export const setPriceMin = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setPriceMinSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setPriceMinSync(value))
    }
  }
}

export const setPriceMinSync = (value) => {
  return {
    type: actionTypes.SET_PRICE_MIN,
    value
  }
}

export const setPriceMax = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(setPriceMaxSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(setPriceMaxSync(value))
    }
  }
}

export const setPriceMaxSync = (value) => {
  return {
    type: actionTypes.SET_PRICE_MAX,
    value
  }
}

export const addAdministrativeAreas= (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(addAdministrativeAreaSync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(addAdministrativeAreaSync(value))
    }
  }
}

export const addAdministrativeAreaSync = (value) => {
  return {
    type: actionTypes.ADD_ADMINISTRATIVEAREA,
    value
  }
}

export const addFilter= (value, n) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(addFilterSync(value, n))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(addFilterSync(value, n))
    }
  }
}

export const addFilterSync = (value, n) => {
  if (value === 'Ambientes'){
    return {
      type: actionTypes.ADD_AMBIENTS,
      n
    }
  }
  else if (value === 'Baños'){
    return {
      type: actionTypes.ADD_BATHROOMS,
      n
    }
  }
  else if (value === 'Dormitorios'){
    return {
      type: actionTypes.ADD_BEDROOMS,
      n
    }
  }
  else if (value === 'Cantidad de naves'){
    return {
      type: actionTypes.ADD_NAVES,
      n
    }
  }
  else{
    return {
      type: actionTypes.ADD_GARAGES,
      n
    }
  }
}

export const togglePanel = () => {
  return {
    type: actionTypes.TOGGLE_PANEL
  }
}

export const retriveFilters = (section) => {
  return (dispatch) => {
    dispatch(retriveOperationTypes(section))
    dispatch(retriveAdministrativeAreas())
  }
}

export const retrivePropertyTypes = (url) => {
  return (dispatch, getStore) => {
    dispatch(fetchSection(url))
  }
}

export const retriveAllPropertyTypes = (url) => {
	return (dispatch, getStore) => {
		api.fetchPropertieTypes({})
      .then((data) => dispatch(receiveAllPropertyTypes(data)))
			.catch((err) => {
				dispatch(error(err))})
  }
}

export const getPropertyTypes = (params) => {
  return (dispatch) => {
    dispatch(loadPropertyTypes())
    api.fetchPropertieTypes(params)
      .then((data) => {
				dispatch(receivePropertyTypes(data))})
      .catch((err) => {
				dispatch(error(err))})
  }
}

export const retriveOperationTypes = (params) => {
  return (dispatch) => {
    api.fetchOperationTypesBySection(params)
      .then((data) => dispatch(receiveOperationTypes(data)))
      .catch((err) => dispatch(error(err)))
  }
}

export const retriveAdministrativeAreas = () => {
  return (dispatch) => {
    dispatch(loadAdministrativeAreas())
  }
}

export const changeOriginSearch = () => {

  return {
    type: actionTypes.SEARCH_FROM_MENU
  }
}

export const changeSearchOrigin = () => {

  return {
    type: actionTypes.SEARCH_FROM_SEARCHBAR
  }
}

export const changeCurrency = (value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(changeCurrencySync(value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(changeCurrencySync(value))
    }
  }
}

export const changeCurrencySync = (value) => {
    return {
      type: actionTypes.CHANGE_CURRENCY,
      value
    }
}

export const checkOperationType = () => {
  return {
    type: actionTypes.CHECK_OPERATION_TYPE
  }
}

export const resetForm = () => {
  return {
    type: actionTypes.RESET_FORM
  }
}

export const resetFilters = () => {
  return (dispatch, getStore) => {
		dispatch(resetSubPropertyType())
    dispatch(resetFiltersSync())
    dispatch(load(urls.PROPERTIES))
  }
}

export const resetFiltersSync = () => {
  return {
    type: actionTypes.RESET_FILTERS
  }
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}

export const onChangeCheckbox= (item, value) => {
  return (dispatch, getStore) => {
    var origin = getStore().searchBar.searchFromMenu
    if (origin){
      dispatch(onChangeCheckboxSync(item, value))
      dispatch(load(urls.PROPERTIES))
    }
    else{
      dispatch(onChangeCheckboxSync(value, n))
    }
  }
}

export const saveSubDepartamento = (value) => {
	return {
		type: actionTypes.ADD_SUB_TIPO_DEPARTAMENTO,
		value: value
	}
}

export const popSubDepartamento = (value) => {
	return {
		type: actionTypes.POP_SUB_TIPO_DEPARTAMENTO,
		value: value
	}
}

export const resetSubPropertyType = () => {
	return {
		type: actionTypes.RESET_SUB_PROPERTY_TYPE
	}
}

export const resetPropertyType = () => {
	return {
		type: actionTypes.RESET_PROPERTY_TYPE
	}
}

export const onChangeCheckboxSync = (item, value) => {
  if (value.name === 'Apto profesional'){
    return {
      type: actionTypes.CHANGE_PROFESSIONAL_USE,
      value
    }
  }
  else if (value.name === 'A estrenar' ){
    return {
      type: actionTypes.CHANGE_NEW,
      value
    }
  }else{
    return (dispatch, getStore) =>  {
			let found = getStore().searchBar.sub_departamento_type.filter(item => item.id == value.id)
			if(found.length) dispatch(popSubDepartamento(value))
      else dispatch(saveSubDepartamento(value))// if(getStore().searchBar.sub_departamento_type.length && getStore().searchBar.sub_departamento_type.id == value.id) value = ''

    }
  }
}

function loadParamsFromUrlSync(data) {
  return {
    type: actionTypes.LOAD_PARAMS_FROM_URL,
    data
  }
}

export const loadParamsFromURL = (data) => {
  return (dispatch, getStore) => {
    if('venture_ids' in data && data['venture_ids'] && data['venture_ids'].length)  {
      dispatch(setVentureId(data['venture_ids'][0]))
    }
    dispatch(loadParamsFromUrlSync(data))
  }

}



// WEBPACK FOOTER //
// ./src/actions/searchBar.js